module.exports = __webpack_public_path__ + "img/feeding-chicken.0bfbc3c9.png";